
import { useState } from "react";
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';

export default function SportsToggle({ value, onChange, horizontal = false }) {
  const [isPlaying, setIsPlaying] = useState(value || "soccer");

  const handleToggle = () => {
    const next = isPlaying === "soccer" ? "basketball" : "soccer";
    setIsPlaying(next);
    if (onChange) onChange(next);
  };

  return (
    <>
      <style>{`
        .sports-switch2 {
          position: relative;
          display: inline-block;
          width: 32px;
          height: 60px;
        }
        .sports-switch2 input {
          opacity: 0;
          width: 0;
          height: 0;
        }
        .sports-slider2 {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;

        background : var(--ptG);

          box-shadow: inset 0 0 0 1px var(--black40);
          border-radius: 100px;
          -webkit-transition: .4s;
          transition: .4s;
        }
        .sports-slider2:before {
          position: absolute;
          content: "";
          height: 24px;
          width: 24px;
          left: 4px;
          bottom: 4px;
          background-color: white;
          border-radius: 100px;
          -webkit-transition: .4s;
          transition: .4s;
        }
        .sports-switch2 input:checked + .sports-slider2 {
          background : var(--ptR);
        }
        .sports-switch2 input:checked + .sports-slider2:before {
          -webkit-transform: translateY(-28px);
          -ms-transform: translateY(-28px);
          transform: translateY(-28px);
        }
        .sports-slider2 .icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, calc(-50% + 14px));
          font-size: 16px;
          color: var(--black80);
          transition: .4s;
          pointer-events: none;
        }
        .sports-switch2 input:checked + .sports-slider2 .icon {
          transform: translate(-50%, calc(-50% - 14px));
          
        }
      `}</style>
      <label
        className="sports-switch2"
        style={horizontal ? { transform: 'rotate(90deg)', display: 'inline-block' } : undefined}
      >
        <input
          type="checkbox"
          checked={isPlaying === "basketball"}
          onChange={handleToggle}
        />
        <span className="sports-slider2">
          <span className="icon" style = {{ paddingTop : "5px"} }>
            {isPlaying === "basketball" ? <SportsBasketballIcon fontSize = "16px" /> : <SportsSoccerIcon fontSize="16px" />}
          </span>
        </span>
      </label>
    </>
  );
}
